import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface EventDetailsReportState {
  totalEvents: number
  totalActiveEvents: number
  totalNotActiveEvents: number
  totalCompletedEvents: number
  totalPerCategory: Record<string, number>
  totalInvitedTeamMember: number
  listOfEvents: Array<{
    _id: string
    id: number
    title: string
    category: string
    createdDate: string
    startDate: string
    endDate: string
    registeredTeamMembers: number
    unregisteredTeamMembers: number
  }>
  loading: boolean
  error: string | null
}

const initialState: EventDetailsReportState = {
  totalEvents: 0,
  totalActiveEvents: 0,
  totalNotActiveEvents: 0,
  totalCompletedEvents: 0,
  totalPerCategory: {},
  totalInvitedTeamMember: 0,
  listOfEvents: [],
  loading: false,
  error: null,
}

export const eventDetailsReportSlice = createSlice({
  name: 'eventDetailsReport',
  initialState,
  reducers: {
    setEventDetailsReportLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setEventDetailsReportError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    setEventDetailsReport: (
      state,
      action: PayloadAction<Omit<EventDetailsReportState, 'loading' | 'error'>>,
    ) => {
      state.totalEvents = action.payload.totalEvents
      state.totalActiveEvents = action.payload.totalActiveEvents
      state.totalNotActiveEvents = action.payload.totalNotActiveEvents
      state.totalCompletedEvents = action.payload.totalCompletedEvents
      state.totalPerCategory = action.payload.totalPerCategory
      state.totalInvitedTeamMember = action.payload.totalInvitedTeamMember
      state.listOfEvents = action.payload.listOfEvents
      state.loading = false
      state.error = null
    },
    clearEventDetailsReport: (state) => {
      state.totalEvents = 0
      state.totalActiveEvents = 0
      state.totalNotActiveEvents = 0
      state.totalCompletedEvents = 0
      state.totalPerCategory = {}
      state.totalInvitedTeamMember = 0
      state.listOfEvents = []
      state.loading = false
      state.error = null
    },
  },
})

export const {
  setEventDetailsReportLoading,
  setEventDetailsReportError,
  setEventDetailsReport,
  clearEventDetailsReport,
} = eventDetailsReportSlice.actions

export default eventDetailsReportSlice.reducer
